<div class="row d-flex " style="margin-top: 20px; text-align: center; overflow-x: hidden; width: 100%;">
    <a (click)="logOut()" style="margin-top:100px; margin-left: 250px; width: 280px;">
        <img class="teamlease-icon" src="./assets/Images/TeamLeaseRegtech_Logo_new.png" alt="Avantis Logo"
            style="display: block; margin: 0 auto; max-width: 100%;" />
    </a>
</div>
<div class="title  d-flex justify-content-center align-items-center flex-column " style="margin-top: 20px;   overflow-x: hidden; width: 100%; "
    data-content="404">
    <h4  [title]="errorCode" >
        {{errorCode}}
    </h4>
</div>

<div class="subtitle  d-flex justify-content-center align-items-center flex-column " style="margin-top: 10px;  overflow-x: hidden; width: 100%; ">
    <h5  [title]="errorMessage" >
        {{ errorMessage }}
    </h5>
</div>

<div class="d-flex justify-content-center align-items-center flex-column" style="margin-top: 30px; width: 100%;">
    <button class="figma-btn-blue" title="Go to Login" (click)="logOut()"  >Go to Login</button>
</div>